module.exports = __webpack_public_path__ + "static/Novartis-3476bd8d3447f477edc32316fcb3acba.png";